// extracted by mini-css-extract-plugin
export default {"topAlbumSection":"Section_topAlbumSection__W346v","title":"Section_title__84eqb","titleDiv":"Section_titleDiv__N3pQn","gridDiv":"Section_gridDiv__WQBNX"};